import { useAsyncFn } from 'react-use-v13';
import { SearchResult } from '@scale/shared/types/chat';
import apiFetch from 'react-scale/lib/api-fetch';

const useFetchSearchResults = (
  processSearchResults: (searchTerm: string, searchResults: SearchResult[]) => void,
) => {
  return useAsyncFn(
    async (searchTerm?: string, model?: string) => {
      if (!searchTerm) {
        throw new Error('No search term is provided');
      }

      const { searchResults } = await apiFetch(null, `internal/contentUnderstanding/googleSearch`, {
        method: 'POST',
        body: { searchTerm, model },
      });

      if (!searchResults) {
        throw new Error('No search results');
      } else {
        processSearchResults(searchTerm, searchResults);
      }
    },
    [processSearchResults],
  );
};

export default useFetchSearchResults;
